import React, { useRef, useState, useEffect, useContext } from "react";
import Context from "../../Context/Context";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../styles/HomeAvaliacao.css";
import axios from "../axios/axios";
import { IoIosCloseCircle } from "react-icons/io";
import NotificacaoTemporariaErro from "../Notificacao/NotificacaoDeErro";
import Modal from "../../utils/Modal";
import { IoAlertCircle } from "react-icons/io5";
import { FaCheckDouble } from "react-icons/fa6";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { AiOutlineUser } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";
import { FaLinkedin } from "react-icons/fa";
import { IoAddCircleSharp } from "react-icons/io5"
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";




const HomeAvaliacao = () => {
  const { usuario, socket, atividades, setAtividades } = useContext(Context);
  const [novaAtividade, setNovaAtividade] = useState({
    atividade: "",
    descricao: "",
    data: new Date(),
    status: "Pendente",
    cor: "#000000",
  });
  const [dataSelecionada, setDataSelecionada] = useState(new Date());
  const [counter, setCounter] = useState(0);
  const [mensagem, setMensagem] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [respondendo, setRespondendo] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // Estado para controlar a visibilidade do modal
  const [isOpen2, setIsOpen2] = useState(false);
  const dropdownRef = useRef(null);
  // const [showEmojis, setShowEmojis] = useState(false);
  const [dropdownAbertoId, setDropdownAbertoId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [destinatario, setDestinatario] = useState("");
  const [show, setShow] = useState(false);
  const [showAtividades, setShowAtividades] = useState();
  const [userDelegado, setUserDelegado] = useState();
  const [destinatarioDelegado, setDestinatarioDelegado] = useState("");
  const [delegando, setDelegando] = useState(false);
  const [error, setError] = useState(false);
  const [atividadeFocus, setAtividadeFocus] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cardsImoveis = [
    {
      imagem: 'https://hansenimoveis.com/wp-content/uploads/2024/08/Mansao-de-alto-luxo-frente-mar-na-Praia-do-Forte-46.jpg',
      titulo: 'Jardim Paulista 82m²',
      descricao: 'Apartamento de alto padrão no coração de SP.',
    },
    {
      imagem: 'https://assets.portalleodias.com/2024/04/foto-mansao-Falcao-capa.png',
      titulo: 'Alphaville 120m²',
      descricao: 'Casa com piscina em condomínio fechado.',
    },
    {
      imagem: 'https://static.arboimoveis.com.br/CA0784_AZ/640x480/mega-mansao-de-luxo-a-venda-a-venda-no-condominio-mansoes-barra-da-tijuca1714489209402lzxbw.jpg',
      titulo: 'Moema 95m²',
      descricao: 'Ótima localização com 2 vagas.',
    },
    {
      imagem: 'data:image/jpeg;base64,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',
      titulo: 'Pinheiros 100m²',
      descricao: 'Design moderno e varanda gourmet.',
    },
    {
      imagem: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSojxjVmYrb-9SJRoIZSuxQ5-_JMMeootHV6g&s',
      titulo: 'Jardins 150m²',
      descricao: 'Apartamento luxuoso com vista panorâmica.',
    },
    {
      imagem: 'https://vault.imob.online/u0243/properties/photos/17345363/Dl8o1wYn3Salg7s7mxsEbtEA-ght08576-web-2.jpg',
      titulo: 'Vila Mariana 88m²',
      descricao: 'Próximo ao metrô, com armários planejados.',
    },
    {
      imagem: 'https://www.primeimoveis.online/imagens/imoveis/20220223180618794.jpg',
      titulo: 'Tatuapé 110m²',
      descricao: 'Cobertura duplex com churrasqueira.',
    },
    {
      imagem: 'https://latinexclusive.com/sites/default/files/styles/property_images_slider/public/api_file_downloads/5c7a20ff202ccf055be69734_2.jpg?itok=9PixFlFf',
      titulo: 'Brooklin 105m²',
      descricao: 'Apartamento em rua tranquila e arborizada.',
    },
  ];


  // const [searchTerm, setSearchTerm] = useState("");

  // const filteredUsers = users.filter((user) =>
  //   user.nome.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // const selectedNome = users.find((u) => u.id === selectedUser)?.nome;

  // Fechar o dropdown se clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // console.log('Listeners ativos:', socket.listeners('notificacao'));
  useEffect(() => {
    const carregarAtividades = async () => {
      try {
        const response = await axios.get(`/home/atividades/${usuario.id}`);
        setAtividades(response.data);
      } catch (error) {
        console.error("Erro ao carregar atividades:", error);
      }
    };

    carregarAtividades();
  }, [usuario.id]);

  // console.log(notificacoes);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownAbertoId(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // console.log(notificacoes);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownAbertoId(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    async function getUsers() {
      try {
        const { data } = await axios.get("/user");
        setUsers(data);
      } catch (error) {
        alert("Falha ao carregar funcionários.");
      }
    }
    getUsers();
  }, []);

  const handleChangeAtividade = (e) => {
    const { name, value } = e.target;

    setNovaAtividade((prevState) => ({
      ...prevState,
      [name]: name === "data" ? new Date(value) : value,
    }));
  };

  const handleAdicionarAtividade = async () => {
    if (novaAtividade.atividade && novaAtividade.descricao) {
      try {
        const response = await axios.post("/home/atividades", {
          usuario_id: usuario.id,
          atividade: novaAtividade.atividade,
          descricao: novaAtividade.descricao,
          data: novaAtividade.data,
          cor: novaAtividade.cor, // Envia a cor ao backend
        });

        socket.emit('receber_atividade', response.data)

        setNovaAtividade({
          atividade: "",
          descricao: "",
          status: "Pendente",
          cor: "#000000",
          data: new Date(),
        });
        setNovaAtividade((prevState) => ({
          ...prevState,
          data: dataSelecionada,
        })); // Reseta a data para o dia atual
        setCounter(counter + 1); // Incrementa o contador para forçar a atualização do componente
      } catch (error) {
        console.error("Erro ao adicionar atividade:", error);
      }
    } else {

      alert("Preencha todos os campos antes de adicionar uma atividade.");
    }
  };

  const handleDelegarAtividade = async () => {
    if (!usuario.role.includes("Supervisor")) return alert("Sem autorização");
    if (+usuario.id == +userDelegado) {
      setError(true);
      return;
    }
    if (novaAtividade.atividade && novaAtividade.descricao) {
      try {
        const response = await axios.post("/home/atividades", {
          solicitante_id: +usuario.id,
          usuario_id: +userDelegado,
          atividade: novaAtividade.atividade,
          descricao: novaAtividade.descricao,
          data: novaAtividade.data,
          cor: novaAtividade.cor, // Envia a cor ao backend
        });

        socket.emit('receber_atividade', response.data)


        // setAtividades((prevAtividades) => [...prevAtividades, response.data].sort((a,b) => new Date(a.data) - new Date(b.data)));
        setNovaAtividade({
          atividade: "",
          descricao: "",
          status: "Pendente",
          cor: "#000000",
          data: new Date(),
        });
        setNovaAtividade((prevState) => ({
          ...prevState,
          data: dataSelecionada,
        })); // Reseta a data para o dia atual
        // setCounter(counter + 1); // Incrementa o contador para forçar a atualização do componente
        setUserDelegado(0);
        setShowAtividades(false);
        setDestinatarioDelegado("");
        setDelegando(false);
      } catch (error) {
        console.error("Erro ao adicionar atividade:", error);
      }
    } else {
      alert("Preencha todos os campos antes de adicionar uma atividade.");
    }
  };
  console.log("testando", atividades);

  const handleDataChange = (date) => {
    setDataSelecionada(date);
    setNovaAtividade({ ...novaAtividade, data: date });
  };

  const handleConcluirAtividade = async (id) => {
    try {
      await axios.patch(`/home/atividades/${id}/concluir`);
      setAtividades((prevAtividades) =>
        prevAtividades.map((atividade) =>
          atividade.id == id
            ? { ...atividade, status: "Concluída" }
            : atividade,
        ),
      );
    } catch (error) {
      console.error("Erro ao concluir atividade:", error);
    }
  };


  const removerAcentos = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const compare = (id, nome) => {
    if (
      userDelegado
        ? +id === +userDelegado
        : removerAcentos(nome)
          .toLowerCase()
          .includes(destinatarioDelegado?.toLowerCase())
    ) {
      return true;
    }
    if (
      userDelegado
        ? +id === +userDelegado
        : nome.toLowerCase().includes(destinatarioDelegado?.toLowerCase())
    ) {
      return true;
    }
    return false;
  };

  console.log("testando outra", atividadeFocus);
  console.log(atividades);


  return (
    <>

      <div className="home-avaliacao-container">

        <div className="flex justify-between items-center mb-4 w-full ">
          <h1 className="ml-64 text-3xl font-bold">Seu Dashboard</h1>
          <div className="flex items-center gap-4">
            <div className="flex justify-center items-center w-20 h-10 bg-white rounded-lg">
              <AiOutlineUser />Perfil

            </div>
            <img className="w-10 h-10 rounded-full" src={usuario.usuario_foto} alt="Rounded avatar" />

          </div>
        </div>

        <div className="flex justify-between items-center w-full mt-[-30px] ">
          <h1 className="ml-64 text-2xl font-bold">{usuario.nome}</h1>
          <div className="flex items-center gap-4">


          </div>
        </div>

        <div className="flex items-start justify-center gap-4 w-full">
          {/* Card fixo à esquerda */}
          {/* Card 1 */}
          <div className="max-w-xs w-full h-72 p-6 bg-black text-white border border-gray-200 rounded-lg shadow-sm">

            <img src="logo.jpg" alt="Logo" className="h-[50px] mb-4" />
            <p className="mb-4 text-sm text-gray-300">
              Confira os leilões em destaque mais recente em nosso site
            </p>
            <a href="#" className="inline-flex items-center text-sm font-medium text-white hover:underline">
              Veja ao lado
              <svg className="w-3 h-3 ml-1 rtl:rotate-180" fill="none" viewBox="0 0 14 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9" />
              </svg>
            </a>
          </div>

          {/* Swiper com 3 cards de 320px */}
          <div className="max-w-[1008px] overflow-x-auto shrink-0">
            <Swiper
              freeMode={true}
              spaceBetween={24}
              slidesPerView={'auto'}
              slidesOffsetBefore={0}
            >
              {cardsImoveis.map((card, index) => (
                <SwiperSlide key={index} style={{ width: '320px' }}>
                  <div className="max-w-xs w-full h-72 bg-white border border-gray-200 rounded-lg shadow-sm">
                    <img
                      src={card.imagem}
                      alt={card.titulo}
                      className="rounded-t-lg w-full h-40 object-cover"
                    />
                    <div className="p-4">
                      <h5 className="mb-2 text-base font-semibold text-gray-900">{card.titulo}</h5>
                      <p className="mb-3 text-sm text-gray-700">{card.descricao}</p>
                      <a
                        href="#"
                        className="inline-flex items-center px-3 py-1 text-xs font-medium text-white bg-black rounded hover:bg-gray-700"
                      >
                        Acesse aqui
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Card fixo à direita: Redes Sociais */}
          <div className="max-w-xs w-full h-72 bg-white border border-gray-200 rounded-lg shadow-sm">
            <img className="rounded-t-lg w-full h-32 object-cover"
              src="https://t2.tudocdn.net/682570?w=824&h=494"
              alt="Imagem do imóvel" />
            <div className="p-4">
              <h5 className="mb-2 text-base font-semibold text-gray-900">Nossas Redes Sociais</h5>
              <p className="mb-3 text-xs text-gray-700">
                Não se esqueça de deixar os likes nas nossas redes sociais.
              </p>
              <div className="flex gap-2 mt-4">
                <a href="#" className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-black rounded hover:bg-blue-800">
                  <FaFacebookSquare />
                </a>
                <a href="#" className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-black rounded hover:bg-pink-600">
                  <GrInstagram />
                </a>
                <a href="#" className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-black rounded hover:bg-blue-700">
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          <div class="max-w-xs w-full mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
            <Calendar
              onChange={handleDataChange}
              className={counter}
              value={dataSelecionada}
              tileContent={({ date }) => {
                const atividadeDoDia = atividades.find((atividade) => {
                  // console.log(atividade.data.split('T')[0], date.toISOString().split('T')[0], atividade.data.split('T')[0] === date.toISOString().split('T')[0])
                  if (atividade.status == "Pendente") {
                    return (
                      new Date(atividade.data.split("T")[0] + " ")
                        .toISOString()
                        .split("T")[0] === date.toISOString().split("T")[0]
                    );
                  }
                });
                return atividadeDoDia?.status == "Pendente" ? (
                  <div
                    style={{
                      backgroundColor: atividadeDoDia.cor || "#ffffff",
                      borderRadius: "50%",
                      width: "80%",
                      height: "80%",
                      margin: "auto",
                    }}
                  ></div>
                ) : null;
              }}
            />
          </div>



          <div className="flex flex-col gap-3 relative">
            <h4 className="text-lg">Registrar uma atividade</h4>
            <div className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Atividade</h5>
                <p className="">Adicione uma nova tarefa</p>
                <p>e acompanhe o seu processo</p>
                <div className="flex justify-end p-1">
                  <IoAddCircleSharp className="text-5xl cursor-pointer hover:text-slate-500" onClick={() => setIsOpen(true)} />
                </div>
              </div>
            </div>
            <div className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Delegar Atividade</h5>
                <p className="">Adicione uma nova tarefa</p>
                <p>e acompanhe o processo da atividade</p>
                <div className="flex justify-end">
                  <IoAddCircleSharp className="text-5xl cursor-pointer hover:text-slate-500 " onClick={() => setIsOpen2(true)} />
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-lg">Ver
              atividades
            </h4>
            <div className="max-w-xs w-full mx-auto l h-44 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 overflow-y-auto">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Pendentes</h5>
                <div>
                  <ul className="flex flex-col gap-2 pr-5  !overflow-x-none  max-h-[400px] w-[100%] m-auto">
                    {atividades?.filter((atv) => atv.status == "Pendente" && atv.solicitante_id != +usuario.id)?.length ==
                      0 && (
                        <p className="text-center">
                          Sem registros de atividades pendente.
                        </p>
                      )}

                    {atividades
                      .filter(({ status }) => status === "Pendente")
                      .map((atividade) => (
                        <div
                          key={atividade.id}
                          className="flex items-start gap-3 cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                          onClick={() => setAtividadeFocus(atividade)}
                        >
                          {/* Bolinha de cor */}
                          <span
                            className="h-3 w-3 rounded-full inline-block mt-1"
                            style={{ backgroundColor: atividade.cor || "#ffffff" }}
                          ></span>

                          <div>
                            {/* Exibe apenas uma vez a atividade */}
                            <p className="text-gray-700 text-sm">
                              {atividade.atividade} -{" "}
                              {new Date(atividade.data.split("T")[0]).toLocaleDateString()}
                            </p>

                            {/* Se tiver solicitante, mostra nome e foto */}
                            {atividade.solicitante_id && (
                              <div className="flex items-center gap-2 mt-1">
                                <img
                                  className="w-8 h-8 rounded-full object-cover"
                                  src={atividade.solicitante.usuario_foto}
                                  alt="Foto do solicitante"
                                />
                                <p className="font-semibold text-xs text-gray-600">
                                  Solicitado por:{" "}
                                  <span className="text-black">
                                    {atividade.solicitante.nome.split(" ")[0]}{" "}
                                    {atividade.solicitante.nome.split(" ").at(-1)}
                                  </span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}


                    {/* {atividades?.filter((atv) => atv.status == "Pendente" && atv.solicitante_id != +usuario.id)?.length > 3 && (
                      <button>Ver mais</button>
                    )} */}
                  </ul>

                </div>
              </div>
            </div>

            <div className="max-w-xs w-full mx-auto l h-40 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 overflow-x-auto">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Concluidas</h5>
                <div>
                  <ul className="flex flex-col gap-2 pr-5  !overflow-x-none  max-h-[400px] w-[100%] m-auto">
                    {atividades?.filter((atv) => atv.status == "Concluída" && atv.solicitante_id != +usuario.id)?.length ==
                      0 && (
                        <p className="text-center">
                          Sem registros de atividades pendente.
                        </p>
                      )}

                    {atividades
                      .filter(({ status }) => status === "Concluída")
                      .map((atividade) => (
                        <div
                          key={atividade.id}
                          className="flex items-start gap-3 cursor-pointer hover:bg-gray-100 p-2 rounded-md"

                        >
                          {/* Bolinha de cor */}
                          <span
                            className="h-3 w-3 rounded-full inline-block mt-1"
                            style={{ backgroundColor: atividade.cor || "#ffffff" }}
                          ></span>

                          <div>
                            {/* Exibe apenas uma vez a atividade */}
                            <p className="text-gray-700 text-sm">
                              {atividade.atividade} -{" "}
                              {new Date(atividade.data.split("T")[0]).toLocaleDateString()}
                            </p>

                            {/* Se tiver solicitante, mostra nome e foto */}
                            {atividade.solicitante_id && (
                              <div className="flex items-center gap-2 mt-1">
                                <img
                                  className="w-8 h-8 rounded-full object-cover"
                                  src={atividade.solicitante.usuario_foto}
                                  alt="Foto do solicitante"
                                />
                                <p className="font-semibold text-xs text-gray-600">
                                  Solicitado por:{" "}
                                  <span className="text-black">
                                    {atividade.solicitante.nome.split(" ")[0]}{" "}
                                    {atividade.solicitante.nome.split(" ").at(-1)}
                                  </span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}


                    {/* {atividades?.filter((atv) => atv.status == "Pendente" && atv.solicitante_id != +usuario.id)?.length > 3 && (
                      <button>Ver mais</button>
                    )} */}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-lg">Ver
              atividades delegadas
            </h4>
            <div className="max-w-xs w-full mx-auto l h-44 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 overflow-y-auto">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Pendentes</h5>
                <div>


                  <ul className="flex flex-col gap-2 pr-5  !overflow-x-none  max-h-[400px] w-[100%] m-auto">


                    {atividades.filter((atv) => atv.status == "Pendente" && usuario.id == atv.solicitante_id).map((atvFiltrada) => (
                      <div key={atvFiltrada.id + 'filtro'}
                        className="cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                        onClick={() => setAtividadeFocus(atvFiltrada)}>


                        <div>
                          <div className="flex items-center gap-2 mt-1">
                            <img
                              className="w-8 h-8 rounded-full object-cover"
                              src={atvFiltrada.usuario.usuario_foto}
                              alt="Foto do solicitante"
                            />
                            <p className="font-semibold text-xs text-gray-600">
                              Delegado para:{" "}
                              <span className="text-black">
                                {atvFiltrada.usuario.nome.split(" ")[0]}{" "}
                                {atvFiltrada.usuario.nome.split(" ").at(-1)}
                              </span>
                            </p>
                          </div>
                        </div>


                        <div className="flex items-center justify-center gap-2">
                          <span
                            className="h-3 w-3 rounded-full inline-block mt-1"
                            style={{ backgroundColor: atvFiltrada.cor || "#ffffff" }}
                          ></span>
                          <p className="text-gray-700 text-sm">
                            {atvFiltrada.atividade} -{" "}
                            {new Date(atvFiltrada.data.split("T")[0]).toLocaleDateString()}
                          </p>
                        </div>

                      </div>
                    ))}
                  </ul>

                </div>
              </div>
            </div>

            <div className="max-w-xs w-full mx-auto l h-40 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 overflow-x-auto">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Concluidas</h5>
                <div>
                  <ul className="flex flex-col gap-2 pr-5 overflow-y-auto !overflow-x-none  max-h-[400px] w-[100%] m-auto">


                    {atividades.filter((atv) => atv.status == "Concluída" && usuario.id == atv.solicitante_id).map((atvFiltrada) => (
                      <div key={atvFiltrada.id + 'filtro'} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md" onClick={() => setAtividadeFocus(atvFiltrada)}>


                        <div>
                          <div className="flex items-center gap-2 mt-1">
                            <img
                              className="w-8 h-8 rounded-full object-cover"
                              src={atvFiltrada.usuario.usuario_foto}
                              alt="Foto do solicitante"
                            />
                            <p className="font-semibold text-xs text-gray-600">
                              Delegado para:{" "}
                              <span className="text-black">
                                {atvFiltrada.usuario.nome.split(" ")[0]}{" "}
                                {atvFiltrada.usuario.nome.split(" ").at(-1)}
                              </span>
                            </p>
                          </div>
                        </div>


                        <div className="flex items-center justify-center gap-2">
                          <span
                            className="h-3 w-3 rounded-full inline-block mt-1"
                            style={{ backgroundColor: atvFiltrada.cor || "#ffffff" }}
                          ></span>
                          <p className="text-gray-700 text-sm">
                            {atvFiltrada.atividade} -{" "}
                            {new Date(atvFiltrada.data.split("T")[0]).toLocaleDateString()}
                          </p>
                        </div>

                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div className="flex flex-col gap-3">
            <h4 className="text-lg ">Progressos de Atividades</h4>
            <div className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="p-4">
                <h5 className="text-lg font-semibold mb-2">Minhas Atividades</h5>

                {/* Cálculos */}
                {(() => {
                  const atividadesFiltradas = atividades?.filter(
                    (atv) => atv.solicitante_id !== +usuario.id
                  ) || [];

                  const total = atividadesFiltradas.length;
                  const pendentes = atividadesFiltradas.filter(atv => atv.status === "Pendente").length;
                  const concluidas = atividadesFiltradas.filter(atv => atv.status === "Concluída").length;

                  const percentPendente = total > 0 ? (pendentes / total) * 100 : 0;
                  const percentConcluida = total > 0 ? (concluidas / total) * 100 : 0;

                  return (
                    <>
                      <p className="mb-1 text-sm">Pendente ({pendentes})</p>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div
                          className="bg-red-600 h-2.5 rounded-full dark:bg-red-500"
                          style={{ width: `${percentPendente}%` }}
                        ></div>
                      </div>

                      <p className="mb-1 text-sm">Concluído ({concluidas})</p>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div
                          className="bg-green-600 h-2.5 rounded-full dark:bg-green-500"
                          style={{ width: `${percentConcluida}%` }}
                        ></div>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>

            <div className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                <div className="p-4">
                  <h5 className="text-lg font-semibold mb-2">Atividades Delegadas</h5>

                  {(() => {
                    // Filtrar atividades delegadas
                    const delegadas = atividades?.filter(
                      (atv) => atv.solicitante_id === usuario.id
                    ) || [];

                    const total = delegadas.length;
                    const pendentes = delegadas.filter((atv) => atv.status === "Pendente").length;
                    const concluidas = delegadas.filter((atv) => atv.status === "Concluída").length;

                    const percentPendente = total > 0 ? (pendentes / total) * 100 : 0;
                    const percentConcluida = total > 0 ? (concluidas / total) * 100 : 0;

                    return (
                      <>
                        <p className="mb-1 text-sm">Pendente ({pendentes})</p>
                        {/* {pendentes === 0 && (
            <p className="text-center text-sm text-gray-500 mb-2">
              Sem registros de atividades pendentes.
            </p>
          )} */}
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                          <div
                            className="bg-red-600 h-2.5 rounded-full dark:bg-red-500 transition-all duration-300"
                            style={{ width: `${percentPendente}%` }}
                          ></div>
                        </div>

                        <p className="mb-1 text-sm">Concluído ({concluidas})</p>
                        {/* {concluidas === 0 && (
            <p className="text-center text-sm text-gray-500 mb-2">
              Sem registros de atividades concluídas.
            </p>
          )} */}
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                          <div
                            className="bg-green-600 h-2.5 rounded-full dark:bg-green-500 transition-all duration-300"
                            style={{ width: `${percentConcluida}%` }}
                          ></div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>


            </div>
          </div>



        </div>

        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          {isOpen && (
            <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-xl relative z-50 space-y-5">
                <h2 className="text-xl font-semibold text-gray-800">Adicionar Atividade</h2>
                <p className="text-gray-500 text-sm">
                  Preencha os campos abaixo para registrar uma nova atividade.
                </p>

                {/* Campo: Título */}
                <div>
                  <label htmlFor="atividade" className="block text-sm font-medium text-gray-700 mb-1">Título</label>
                  <input
                    type="text"
                    name="atividade"
                    value={novaAtividade.atividade}
                    onChange={handleChangeAtividade}
                    placeholder="Ex: Reunião com cliente"
                    className="w-full px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>

                {/* Campo: Descrição */}
                <div>
                  <label htmlFor="descricao" className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                  <textarea
                    name="descricao"
                    value={novaAtividade.descricao}
                    onChange={handleChangeAtividade}
                    placeholder="Detalhes sobre a atividade..."
                    className="w-full px-4 py-2 border rounded-xl shadow-sm resize-none h-24 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>

                {/* Campo: Data e Cor */}
                <div className="flex gap-4">
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                    <input
                      type="date"
                      name="data"
                      value={
                        novaAtividade.data instanceof Date
                          ? novaAtividade.data.toISOString().split("T")[0]
                          : ""
                      }
                      onChange={handleChangeAtividade}
                      className="w-full px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Cor</label>
                    <input
                      type="color"
                      name="cor"
                      value={novaAtividade.cor || "#000000"}
                      onChange={handleChangeAtividade}
                      className="w-full h-10 border rounded-xl cursor-pointer p-1"
                    />
                  </div>
                </div>

                {/* Ações */}
                <div className="flex justify-end gap-3 pt-4">
                  <button
                    onClick={() => setIsOpen(false)}
                    className="px-4 py-2 rounded-xl bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                  >
                    Cancelar
                  </button>

                  <button
                    className="bg-black text-white rounded-lg px-4 py-2 transition w-[50%] hover:!bg-gray-700"
                    onClick={

                      userDelegado
                        ? handleDelegarAtividade
                        : handleAdicionarAtividade

                    }
                  >
                    Adicionar Atividade
                  </button>
                  {/* <button
            onClick={() => {
              // ação de confirmação
              setIsOpen(false);
            }}
            className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
          >
            Confirmar
          </button> */}
                </div>
              </div>
            </div>
          )}
        </div>


        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          {isOpen2 && (
            <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50 px-4">
              <div className="bg-white rounded-2xl p-6 max-w-xl w-full shadow-xl space-y-5 z-50">
                <h2 className="text-xl font-semibold text-gray-800">Delegar Atividade</h2>

                {/* Campo Título */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Título</label>
                  <input
                    type="text"
                    placeholder="Ex: Reunião com cliente"
                    value={novaAtividade.atividade}
                    name="atividade"
                    onChange={handleChangeAtividade}
                    className="w-full px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>

                {/* Campo Descrição */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                  <textarea
                    placeholder="Detalhes sobre a atividade"
                    value={novaAtividade.descricao}
                    name="descricao"
                    onChange={handleChangeAtividade}
                    className="w-full px-4 py-2 border rounded-xl shadow-sm resize-none h-24 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                </div>

                {/* Campo Data e Cor */}
                <div className="flex gap-4">
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                    <input
                      type="date"
                      value={
                        novaAtividade.data instanceof Date
                          ? novaAtividade.data.toISOString().split("T")[0]
                          : ""
                      }
                      name="data"
                      onChange={handleChangeAtividade}
                      className="w-full px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Cor</label>
                    <input
                      type="color"
                      value={novaAtividade.cor || "#000000"}
                      name="cor"
                      onChange={handleChangeAtividade}
                      className="w-full h-10 border rounded-xl cursor-pointer p-1"
                    />
                  </div>
                </div>

                {/* Campo Usuário Destinatário */}
                <div className="space-y-3 border rounded-xl p-4 bg-gray-50">
                  <label className="block text-sm font-medium text-gray-700">Delegar para:</label>
                  <input
                    value={destinatarioDelegado}
                    onChange={(e) => {
                      if (e.target.value?.length > 0) setShowAtividades(true);
                      setDestinatarioDelegado(e.target.value);
                    }}
                    type="text"
                    placeholder="Digite o nome do usuário"
                    className="w-full px-4 py-2 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />

                  {destinatarioDelegado.length === 0 && !showAtividades ? (
                    <div
                      onClick={() => setShowAtividades(true)}
                      className="text-center cursor-pointer text-sm text-blue-600 hover:underline"
                    >
                      Selecione um usuário
                    </div>
                  ) : (
                    <div className="max-h-[120px] overflow-y-auto space-y-2">
                      {users
                        ?.filter(({ id, nome }) => compare(id, nome))
                        ?.map(({ id, nome, usuario_foto }) => (
                          <div
                            key={id}
                            onClick={() => setUserDelegado(id)}
                            className={`flex items-center gap-3 p-2 rounded-lg cursor-pointer transition hover:bg-gray-200 ${+userDelegado === +id ? "bg-gray-100 border border-blue-500" : ""
                              }`}
                          >
                            <img
                              className="rounded-full"
                              width={40}
                              src={
                                usuario_foto ||
                                "https://cdn-icons-png.flaticon.com/512/64/64572.png"
                              }
                              alt={nome}
                            />
                            <p className="font-medium text-gray-800">{nome}</p>
                            {+userDelegado === +id && (
                              <button
                                className="ml-auto text-red-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setUserDelegado(0);
                                }}
                              >
                                <IoIosCloseCircle size={20} />
                              </button>
                            )}
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                {/* Ações */}
                <div className="flex justify-end items-center gap-4 pt-4">
                  <button
                    onClick={() => setIsOpen2(false)}
                    className="px-4 py-2 rounded-xl bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                  >
                    Cancelar
                  </button>

                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded-xl hover:bg-blue-700 transition"
                    onClick={handleDelegarAtividade}
                  >
                    Delegar Atividade
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>



        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <h2 className="text-xl font-semibold mb-4">Título do Modal</h2>
          <p className="text-gray-700 mb-4">Aqui vai o conteúdo do modal.</p>
          <button
            className="mt-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
            onClick={() => setIsModalOpen(false)}
          >
            Fechar
          </button>
        </Modal>

        <Modal contrast="white" active={Boolean(atividadeFocus)} setActive={setAtividadeFocus} >
          <div className="!w-full flex flex-col bg-gray-200 !pb-4">
            <p className="first-letter:capitalize tracking-wide font-bold px-4 py-4 bg-gray-800 text-white">{atividadeFocus?.atividade}</p>
            <p className="first-letter:capitalize px-4 py-4">{atividadeFocus?.descricao}</p>
            <button
              className="reset-button !bg-gray-800 !text-center !self-start !rounded-md !tracking-wider !text-md !p-2 !ml-4 hover:!bg-gray-600 disabled:!cursor-not-allowed"
              disabled={usuario.id != atividadeFocus?.usuario_id}
              onClick={() => {
                handleConcluirAtividade(atividadeFocus.id)
                setAtividadeFocus(false)
              }}
            >
              Concluir
            </button>
          </div>

        </Modal>
        {error && (
          <NotificacaoTemporariaErro
            mensagem="Você não pode delegar atividade para si."
            onClose={() => setError(false)}
            mostrar={error}
          />
        )}

      </div>
    </>
  );
};

export default HomeAvaliacao;